import type { ComponentType } from 'react';
import type { VoucherFinish } from 'content/gifting/voucherConfig';
import { GiftIcon } from './GiftIcon';

export type GiftCardNote = {
  icon: ComponentType<{ className?: string }>;
  /** A `cart` namespace key taking `{last4}`. */
  message: string;
};

/** The note for a card whose design isn't known. */
export const GIFT_CARD_NOTE_DEFAULT: GiftCardNote = {
  icon: GiftIcon,
  message: 'sharedCart.giftCard.banner',
};

/** The applied note per card design. Every design uses the default for now. */
export const GIFT_CARD_NOTES: Record<VoucherFinish, GiftCardNote> = {
  holidays: GIFT_CARD_NOTE_DEFAULT,
  diwali: GIFT_CARD_NOTE_DEFAULT,
  birthday: GIFT_CARD_NOTE_DEFAULT,
  baby: GIFT_CARD_NOTE_DEFAULT,
  marble: GIFT_CARD_NOTE_DEFAULT,
  halftone: GIFT_CARD_NOTE_DEFAULT,
  prism: GIFT_CARD_NOTE_DEFAULT,
  'aster-black': GIFT_CARD_NOTE_DEFAULT,
  'bionic-gold': GIFT_CARD_NOTE_DEFAULT,
  'space-silver': GIFT_CARD_NOTE_DEFAULT,
};
